import axios from 'axios';
axios.defaults.withCredentials = false;


const ReassAxios = axios.create({
    baseURL:"https://www.sodesoft.net:9075/",
    crossdomain: true,
    redirect: "follow", 
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8"
    }
});

const ArcsAxios = axios.create({
    baseURL:"https://www.sodesoft.net:9072/",
    crossdomain: true,
    redirect: "follow", 
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8",
    }
});



export default{
  ReassAxios,
  ArcsAxios,
};